import React from "react";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import ArrowLeftIcon from "@mui/icons-material/KeyboardBackspace";
import { Typography, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import DualListItem from "./DualListItem";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    background: theme.palette.background.default,
    maxHeight: theme.spacing(80),
    minHeight: theme.spacing(50),
    height: "100%",
    display: "flex",
    flexDirection: "column"
  },
  radioGroup: {
    justifyContent: "center",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2)
  },
  radioLabel: {
    marginRight: theme.spacing(6)
  },
  helperText: {
    maxWidth: 350,
    marginTop: theme.spacing(4.5),
    marginLeft: "auto",
    marginRight: "auto"
  }
}));

const getDualListItem = (item, disabled, onAddToUnselectedList) => {
  return (
    <DualListItem
      key={item.id}
      details={item}
      hideArrow={item.hideArrow}
      icon={<ArrowLeftIcon />}
      onAction={() => onAddToUnselectedList(item)}
      disabled={disabled}
    />
  );
};

const SelectedList = ({
  items,
  onAddToUnselectedList,
  onRemoveAll,
  header,
  listAction,
  removeAllButtonText,
  hideRemoveAllButton,
  disabled,
  renderList
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleAddToUnselectedList = index => item => {
    onAddToUnselectedList(item, index);
  };

  return (
    <div className={classes.root} data-qa="selected-list">
      <Typography variant="h5">{header}</Typography>
      {renderList ? (
        renderList(items, (item, index) =>
          getDualListItem(item, disabled, handleAddToUnselectedList(index))
        )
      ) : (
        <Box flex="1" overflow="auto" mt={3}>
          {items.map((item, index) =>
            getDualListItem(item, disabled, handleAddToUnselectedList(index))
          )}
        </Box>
      )}
      <Box
        display="flex"
        justifyContent="space-between"
        mt={3}
        alignItems="center"
      >
        <div>{listAction}</div>
        {!hideRemoveAllButton && (
          <Button
            color="primary"
            onClick={onRemoveAll}
            disabled={disabled}
            data-qa="selected-list-remove-all-btn"
          >
            {removeAllButtonText
              ? removeAllButtonText
              : t("dualList.removeAllBtn")}
          </Button>
        )}
      </Box>
    </div>
  );
};

SelectedList.propTypes = {
  items: PropTypes.array,
  onAddToUnselectedList: PropTypes.func.isRequired,
  onRemoveAll: PropTypes.func.isRequired,
  hideRemoveAllButton: PropTypes.bool,
  disabled: PropTypes.bool
};

SelectedList.defaultProps = {
  items: []
};

export default SelectedList;
